import type { FC, SVGProps } from 'react';

const FileEarmarkTextIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 7C5.72386 7 5.5 7.22386 5.5 7.5C5.5 7.77614 5.72386 8 6 8H11C11.2761 8 11.5 7.77614 11.5 7.5C11.5 7.22386 11.2761 7 11 7H6Z"
        fill="#667180"
      />
      <path
        d="M5.5 9.5C5.5 9.22386 5.72386 9 6 9H11C11.2761 9 11.5 9.22386 11.5 9.5C11.5 9.77614 11.2761 10 11 10H6C5.72386 10 5.5 9.77614 5.5 9.5Z"
        fill="#667180"
      />
      <path
        d="M5.5 11.5C5.5 11.2239 5.72386 11 6 11H8C8.27614 11 8.5 11.2239 8.5 11.5C8.5 11.7761 8.27614 12 8 12H6C5.72386 12 5.5 11.7761 5.5 11.5Z"
        fill="#667180"
      />
      <path
        d="M10 0H4.5C3.39543 0 2.5 0.89543 2.5 2V14C2.5 15.1046 3.39543 16 4.5 16H12.5C13.6046 16 14.5 15.1046 14.5 14V4.5L10 0ZM10 1V3C10 3.82843 10.6716 4.5 11.5 4.5H13.5V14C13.5 14.5523 13.0523 15 12.5 15H4.5C3.94772 15 3.5 14.5523 3.5 14V2C3.5 1.44772 3.94772 1 4.5 1H10Z"
        fill="#667180"
      />
    </svg>
  );
};

export default FileEarmarkTextIcon;
